import { getAuthHeaders } from '../utils/authHeaders';
import { createFormPdf } from '../utils/formPdf';

const API_URL = 'https://app.pvslimited.co.uk/api';

const formatDateForSubject = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(d.getTime())) return dateStr;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const sendBumpTestEmail = async (formData) => {
  try {
    const blob = await createFormPdf({
      title: 'GAS DETECTOR BUMP TEST',
      ref: 'Ref: PVS-GBT-001 | Version: 1.0',
    }, (pdf) => {
      pdf.field('Inspector', formData.inspectorName);
      pdf.field('Date', formatDateForSubject(formData.date));
      pdf.section('DAILY CHECKS');
      pdf.check('Gas Detector Battery level ok?', formData.batteryLevelOk);
      pdf.check('Gas Detector free from damage?', formData.freeFromDamage);
      pdf.check('Gas Detector In Calibration?', formData.inCalibration);
      pdf.check(
        'Gas Detector Visual LEL levels increased when exposed to Propane?',
        formData.lelIncreasedWithPropane
      );
    });

    const formattedDate = formatDateForSubject(formData.date);
    const subject = `${formData.inspectorName} ${formattedDate} Gas detector bump test`;
    const safeName = String(formData.inspectorName || 'inspector').replace(/\s+/g, '_');

    const formDataToSend = new FormData();
    formDataToSend.append(
      'file',
      blob,
      `Bump_Test_${safeName}_${formData.date}_${Date.now()}.pdf`
    );
    formDataToSend.append('inspectorName', formData.inspectorName);
    formDataToSend.append('date', formData.date);
    formDataToSend.append('subject', subject);
    formDataToSend.append('batteryLevelOk', formData.batteryLevelOk);
    formDataToSend.append('freeFromDamage', formData.freeFromDamage);
    formDataToSend.append('inCalibration', formData.inCalibration);
    formDataToSend.append('lelIncreasedWithPropane', formData.lelIncreasedWithPropane);
    formDataToSend.append('formType', 'bump-test');

    const response = await fetch(`${API_URL}/send-bump-test-email`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formDataToSend,
    });

    if (!response.ok) {
      const errorText = await response.text();
      let message = 'Failed to submit bump test.';
      try {
        const payload = JSON.parse(errorText);
        if (payload?.error) message = payload.error;
      } catch {
        if (errorText) message = errorText;
      }
      throw new Error(message);
    }

    return response.json();
  } catch (error) {
    console.error('Error in sendBumpTestEmail:', error);
    throw error;
  }
};

export default sendBumpTestEmail;
